import React, { useState } from 'react';
import { Button, Link } from '@mui/material';
import ForgotPasswordDialog from './ForgotPasswordDialog';

const ForgotPasswordLink = ({ variant = 'link', onSuccess, ...props }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleSuccess = () => {
    setDialogOpen(false);
    if (onSuccess) {
      onSuccess();
    }
  };

  if (variant === 'button') {
    return (
      <>
        <Button
          variant="text"
          color="primary"
          onClick={() => setDialogOpen(true)}
          {...props}
        >
          نسيت كلمة المرور؟
        </Button>
        <ForgotPasswordDialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          onSuccess={handleSuccess}
        />
      </>
    );
  }

  return (
    <>
      <Link
        component="button"
        variant="body2"
        onClick={() => setDialogOpen(true)}
        sx={{ 
          cursor: 'pointer',
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'underline'
          }
        }}
        {...props}
      >
        نسيت كلمة المرور؟
      </Link>
      <ForgotPasswordDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onSuccess={handleSuccess}
      />
    </>
  );
};

export default ForgotPasswordLink;